module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.emit
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.iconClass,
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af1526a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iButton/iButton.vue
// module id = 765
// module chunks = 10